/** @internal */
export class TouchDblclickHandler {

    private _touchLastStartEvent: {
        event: any,
        time: number,
    };


    constructor(private defaultCallback?: (touchEvent) => void) {
    }

    dispose() {
        // NOP
    }

    public handleTouchStart(e, callback?: (touchEvent) => void) {

        if (e.touches.length != 1) return;

        callback = callback || this.defaultCallback;

        var last = this._touchLastStartEvent;

        if (last) {

            var diff = (Date.now() - last.time);

            if (diff < 500) {

                var t1 = last.event.touches[0];
                var t2 = e.touches[0];

                var diffX = Math.abs(t1.screenX - t2.screenX);
                var diffY = Math.abs(t1.screenY - t2.screenY);

                if ((diffX <= 30) && (diffY <= 30)) {
                    callback(t2);
                    this._touchLastStartEvent = null;
                    return;
                }

            }

        }

        this._touchLastStartEvent = {
            event: e,
            time: Date.now()
        };

        callback(null);

    }


}
